// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/securitypipelineservice/security_pipeline.actions.go

export const CREATE_PULL_REQUEST =
  "mondoo.integrations.securitypipeline.SecurityPipelineIntegration.CreatePullRequest";
